export default __webpack_public_path__ + "static/media/log1.7b21b218.svg";